export default __webpack_public_path__ + "static/media/blog3.6291ee7c.svg";